import React, { useState } from "react";
import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import { ManageLeadsComponent } from "../Pages/Telesaleleads/ManageLeadsComponent";
import { SearchLeadsComponent } from "../Pages/Telesaleleads/SearchLeadsComponent";
import { NotificationsComponent } from '../Pages/Leads/NotificationsComponent'
import { MalkiyetContactComponent } from "../Pages/Staff/MalkiyetContactComponent";
import { TargetComponent } from "../Pages/TargetComponent";
import { PoliciesComponent } from "../Pages/PoliciesComponent";
import { Unauthorized } from "./Unauthorized";
import { NotFound } from "./NotFound";
import { RequireAuth } from "./RequireAuth";
import { ChangePasswordComponent } from "../Pages/ChangePassword";
import { FavouriteLeadsComponent } from "../Pages/Telesaleleads/FavouriteLeadsComponent";
import { TelasaleLayout } from "./TelesaleLayout";
import { TelesalesDashboard } from "../Components/Telesales/Telesalesdashboard/TelesalesDashboard";
import { TodoList } from "../Pages/Telesaleleads/TodoList";
import { TelesalesCalendarComponent } from "../Pages/Telesales/TelesalesCalendarComponent";
import { TsActivityComponent } from "../Pages/TsActivity";

export const TelesaleappRoutes = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <Routes>
      <Route path="/" element={<TelasaleLayout />}>
        <Route path="changePassword/:token" element={<ChangePasswordComponent />} />
        <Route path="unauthorized" element={<Unauthorized />} />
        <Route
          element={
            <RequireAuth
              allowedRoles={[
                "ts",
                "TS", // Add uppercase variant
              ]}
            />
          }
        >
          <Route index element={<TelesalesDashboard showModal={showModal} setShowModal={setShowModal} />} />
        </Route>
        <Route
          path="leads"
          element={
            <RequireAuth
              allowedRoles={[
                "ts",
                "TS"
              ]}
            />
          }
        >
          <Route index element={<SearchLeadsComponent />} />
          <Route path="favourite" element={<FavouriteLeadsComponent />} />
          <Route path="calendar" element={<TelesalesCalendarComponent />} />
          <Route path="notifications" element={<NotificationsComponent />} />
          <Route path="manageleads" element={<ManageLeadsComponent />} />
          <Route
            path="todolist"
            element={
              <TodoList />
            }
          />
        </Route>

        <Route
          path="staff"
          element={
            <RequireAuth
              allowedRoles={[
                "ceo",
                "admin",
                "ts",
                "TS",
              ]}
            />
          }
        >
          <Route index element={<MalkiyetContactComponent />} />
        </Route>

        <Route
          element={
            <RequireAuth
              allowedRoles={[
                "ts",
                "TS",
              ]}
            />
          }
        >
          <Route path="targets" element={<TargetComponent />} />
        </Route>
        <Route
          element={
            <RequireAuth
              allowedRoles={[
                "ts",
                "TS",
              ]}
            />
          }
        >
          <Route path="policies" element={<PoliciesComponent />} />
        </Route>

        <Route
          element={
            <RequireAuth
              allowedRoles={[
                "ts",
                "TS",
              ]}
            />
          }
        >
          <Route path="reports" element={<Outlet />}>
            <Route index element={<Navigate replace to="tsactivity" />} />
            <Route path="tsactivity" element={<TsActivityComponent />} />
          </Route>
        </Route>
        <Route path="/notfound" element={<NotFound />} />
        <Route path="*" element={<Navigate replace to="/notfound" />} />
      </Route>
    </Routes>
  );
};
